import { render } from "./APage.vue?vue&type=template&id=22d05de1"
import script from "./APage.vue?vue&type=script&lang=js"
export * from "./APage.vue?vue&type=script&lang=js"

import "./APage.vue?vue&type=style&index=0&id=22d05de1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__